var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 136,
    viewBox: "0 0 67 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.034 0.00292969H16.941C7.58474 0.00292969 0 7.58766 0 16.9439V26.5611C0 35.9174 7.58474 43.5021 16.941 43.5021H104.034C113.39 43.5021 120.975 35.9174 120.975 26.5611V16.9439C120.975 7.58766 113.39 0.00292969 104.034 0.00292969Z",
    fill: "#91E0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7344 63.169L71.7188 48.1534C65.512 41.9466 55.4489 41.9466 49.2421 48.1534L34.2266 63.169C28.0198 69.3757 28.0198 79.4389 34.2266 85.6456L49.2421 100.661C55.4489 106.868 65.512 106.868 71.7188 100.661L86.7344 85.6456C92.9411 79.4389 92.9411 69.3757 86.7344 63.169Z",
    fill: "#91E0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5308 136.003C29.5308 119.052 43.3856 105.311 60.487 105.311C77.5885 105.311 91.4433 119.052 91.4433 136.003",
    fill: "#91E0DF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeCardIcon);
export default __webpack_public_path__ + "static/media/Welcome_Card_icon.2a4bc39395cc0462f9b31c50ae233de1.svg";
export { ForwardRef as ReactComponent };